import styles from "./ParameterApplyModalContent.module.css";
import modal from "components/Modal/ModalContent.module.css";
import cn from "classnames";
import { Button } from "components/Button/Button";
import { IconButton } from "components/Button/IconButton";
import { IconCross } from "components/Icons/IconCross";
import { Notification } from "components/Notification";

export function AllQueriesDeprecatedModalContent(props: { close: () => void }) {
  return (
    <div className={cn(modal.body)}>
      <div className={modal.header}>
        <div className={modal.titleRow}>
          <h2>Deprecated datasets</h2>

          <IconButton size="XS" theme="ghost" onClick={props.close}>
            <IconCross />
          </IconButton>
        </div>
      </div>

      <div className={cn(modal.content, styles.content)}>
        <Notification
          level="warning"
          dismissable={false}
          title="*Deprecated datasets"
          description={
            <>
              All the queries on this dashboard run against deprecated datasets
              and can no longer be executed.
            </>
          }
        />
      </div>

      <div className={modal.buttons}>
        <Button size="M" theme="tertiary" onClick={props.close}>
          Close
        </Button>
      </div>
    </div>
  );
}
